import { Button, Tooltip, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
export default function EntregasExportarButton({ data = [] }) {
  const exportarExcel = async () => {
    if (!data.length) {
      message.warning("No hay datos para exportar");
      return;
    }
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Entregas");
    worksheet.columns = [
      { header: "Participante", key: "participante", width: 30 },
      { header: "Identificación", key: "identificacion", width: 20 },
      { header: "Proyecto", key: "proyecto", width: 30 },
      { header: "Producto", key: "producto", width: 30 },
      { header: "Cantidad", key: "cantidad", width: 12 },
      { header: "Departamento", key: "departamento", width: 20 },
      { header: "Municipio", key: "municipio", width: 20 },
      { header: "Tipo Entrega", key: "tipo", width: 18 },
      { header: "Fecha Entrega", key: "fecha", width: 18 },
      { header: "Carpeta", key: "carpeta", width: 20 },
      { header: "Archivo", key: "archivo", width: 25 }
    ];
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = {
        bold: true,
        color: { argb: "FFFFFFFF" }
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF042956" }
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center"
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
    data.forEach((item) => {
      worksheet.addRow({
        participante: item.nombre_participante,
        identificacion: item.numero_identificacion,
        proyecto: item.proyecto,
        producto: item.nombre_producto,
        cantidad: item.cantidad,
        departamento: item.departamento,
        municipio: item.municipio,
        tipo: item.tipo_entrega === 1 ? "Participante" : "Organización",
        fecha: item.fecha_entrega
          ? dayjs(item.fecha_entrega).format("DD/MM/YYYY")
          : "",
        carpeta: item.carpeta || "",
        archivo: item.nombre_archivo || ""
      });
    });
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) return;
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
        cell.alignment = {
          vertical: "middle"
        };
      });
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer]),
      `entregas_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`
    );
  };

  return (
    <Tooltip title="Exportar datos a Excel">
      <Button
        icon={<DownloadOutlined />}
        onClick={exportarExcel}
      >
        Exportar
      </Button>
    </Tooltip>
  );
}